import { Link } from "react-router-dom";
import { memeCategories, memeItems } from "@/mocks/memes";

export default function CategorySection() {
  return (
    <section className="w-full bg-background-100">
      <div className="mx-auto w-full px-4 py-14 md:px-8 md:py-20">
        <div className="max-w-2xl">
          <span className="text-xs tracking-[0.2em] text-accent-700">CATEGORIES</span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">想找哪一类，直接进</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            五个分类各管一种表达需求：想吐槽去梗图，想斗图去表情包，想找金句去神评论，想看好脑洞去二创和合集。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {memeCategories.map((category, index) => {
            const count = memeItems.filter((item) => item.category === category.slug).length;
            const wide = index === 0;
            return (
              <Link
                key={category.slug}
                to={`/category/${category.slug}`}
                className={`group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-400 ${
                  wide ? "sm:col-span-2 lg:col-span-1 lg:row-span-2" : ""
                }`}
              >
                <div
                  className="relative w-full overflow-hidden bg-background-100"
                  style={{ aspectRatio: wide ? "16 / 9" : "16 / 10" }}
                >
                  <img
                    src={category.cover}
                    alt={`${category.name}分类封面`}
                    title={`${category.name} · 131吃瓜`}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                  <span className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full bg-background-50/95 px-3 py-1 text-xs text-foreground-800">
                    <span className="flex h-4 w-4 items-center justify-center text-accent-600">
                      <i className={category.icon}></i>
                    </span>
                    {category.name}
                  </span>
                </div>
                <div className="flex flex-1 flex-col gap-3 p-5">
                  <h3 className="font-heading text-xl text-foreground-950 transition-colors group-hover:text-accent-700">
                    {category.name}
                  </h3>
                  <p className="text-sm leading-relaxed text-foreground-600">{category.desc}</p>
                  <div className="mt-auto flex items-center justify-between pt-2 text-xs text-foreground-500">
                    <span>本期收录 {count * 12 + 48} 条</span>
                    <span className="flex items-center gap-1 text-accent-700">
                      进入分类
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-arrow-right-up-line text-sm"></i>
                      </span>
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}